/* Bellyful OS: canvas celebration, isolated from cart updates. */
(() => {
  'use strict';
  const palette = ['#BDDE59','#FF9EBB','#EBC779','#EDE8DD','#B3D9BC','#fff2ca','#f2ad74'];
  const rand = (a,b)=> Math.random()*(b-a)+a;
  const pick = list => list[Math.floor(rand(0,list.length))];
  let overlay=null,ctx=null,frame=0,pieces=[],sparks=[],width=0,height=0,start=0,last=0,onDone=null,finishTimer=0;
  function destroy() {
    cancelAnimationFrame(frame); frame=0;
    clearTimeout(finishTimer); finishTimer=0;
    overlay?.remove(); overlay=null;ctx=null;pieces=[];sparks=[];
  }
  function confetti(n){for(let i=0;i<n;i++)pieces.push({x:rand(8,width-8),y:rand(-190,25),vx:rand(-1.6,1.6),vy:rand(1.3,3.1),r:rand(2,5),h:rand(5,13),angle:rand(0,6.28),spin:rand(-.11,.11),color:pick(palette)});}
  function sparksAt(points,cx,cy,delay){for(const p of points)sparks.push({x:cx,y:cy,tx:cx+p[0],ty:cy+p[1],vx:rand(-1,1),vy:rand(-1,1),cx,cy,r:rand(1.3,2.6),color:pick(palette),delay});}
  function radial(cx,cy,n,delay){const pts=[];for(let i=0;i<n;i++){const angle=i/n*Math.PI*2,r=rand(25,65);pts.push([Math.cos(angle)*r,Math.sin(angle)*r]);}sparksAt(pts,cx,cy,delay);}
  function wink(cx,cy){
    const off=document.createElement('canvas');off.width=380;off.height=220;
    const o=off.getContext('2d');if(!o)return;
    o.font='900 167px Arial, sans-serif';o.textAlign='center';o.textBaseline='middle';o.fillStyle='#fff';o.fillText(';b',190,105);
    const pix=o.getImageData(0,0,380,220).data,pts=[];
    const scale=Math.min(width/425,1);
    for(let y=15;y<206;y+=5)for(let x=22;x<360;x+=5)
      if(pix[(y*380+x)*4+3]>165 && Math.random()<.75)pts.push([(x-190)*.52*scale,(y-108)*.52*scale]);
    sparksAt(pts,cx,cy,410);
  }
  function tick(now){
    const dt=Math.min(50,now-last);last=now;const elapsed=now-start;
    ctx.clearRect(0,0,width,height);
    pieces=pieces.filter(p=>{
      p.y+=p.vy*dt*.06;p.x+=p.vx*dt*.06+Math.sin(elapsed*.0015+p.angle)*.18;p.angle+=p.spin*dt*.045;
      if(p.y>height+25)return false;
      ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.angle);ctx.fillStyle=p.color;ctx.fillRect(-p.r,-p.h/2,p.r*2,p.h);ctx.restore();return true;
    });
    sparks=sparks.filter(s=>{
      const age=elapsed-s.delay;if(age<0)return true;
      const travel=550,hold=460,decay=1300;let fade=1;
      if(age<travel){const u=1-Math.pow(1-age/travel,3);s.x=s.cx+(s.tx-s.cx)*u;s.y=s.cy+(s.ty-s.cy)*u;}
      else if(age<travel+hold){s.x=s.tx;s.y=s.ty;}
      else {const u=(age-travel-hold)/decay;s.x=s.tx+s.vx*u*100;s.y=s.ty+s.vy*u*100+u*u*75;fade=Math.max(0,1-u);}
      if(fade<=0)return false;
      ctx.save();ctx.globalAlpha=fade;ctx.shadowColor=s.color;ctx.shadowBlur=9;ctx.fillStyle=s.color;ctx.beginPath();ctx.arc(s.x,s.y,s.r,0,Math.PI*2);ctx.fill();ctx.restore();return true;
    });
    if(elapsed<3500&&(pieces.length||sparks.length))frame=requestAnimationFrame(tick);
    else end();
  }
  function end(){const callback=onDone;onDone=null;destroy();callback?.();}
  function play(stage,callback){
    if (overlay) { onDone=callback; return; }
    destroy();onDone=callback;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){end();return;}
    const drawer=document.querySelector('#BellyfulCartDrawer');
    if(!drawer?.classList.contains('is-open')){end();return;}
    const panel=drawer.querySelector('[data-drawer-panel]');if(!panel){end();return;}
    const rect=panel.getBoundingClientRect();width=Math.max(10,rect.width);height=Math.max(10,rect.height);
    overlay=document.createElement('div');overlay.className='bf-cart-fx';overlay.setAttribute('aria-hidden','true');
    overlay.style.cssText=`left:${rect.left}px;top:${rect.top}px;width:${width}px;height:${height}px`;
    const canvas=document.createElement('canvas');const dpr=Math.min(devicePixelRatio||1,2);canvas.width=Math.round(width*dpr);canvas.height=Math.round(height*dpr);
    canvas.style.cssText='display:block;width:100%;height:100%';ctx=canvas.getContext('2d');
    if(!ctx){end();return;}ctx.setTransform(dpr,0,0,dpr,0,0);overlay.appendChild(canvas);
    if(stage>=3){
      const badge=document.createElement('div');badge.className='bf-cart-fx-badge';
      badge.textContent=drawer.dataset.fireworksBadge||';b PARTY UNLOCKED!';overlay.appendChild(badge);
      confetti(125);wink(width*.51,height*.36);radial(width*.18,height*.18,45,0);radial(width*.80,height*.2,45,220);radial(width*.23,height*.52,30,680);radial(width*.77,height*.54,30,810);
    }else confetti(stage===2?95:35);
    document.body.appendChild(overlay);
    start=performance.now();last=start;frame=requestAnimationFrame(tick);
    finishTimer=setTimeout(end,3700);
  }
  window.BellyfulCartFX={play,stop:destroy};
})();
